import React from 'react';
import { Flex } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { Option } from 'types/general.types';
import { SignUpFormFields } from 'app/components/SignUp/SignUpForm/types';
import { ChakraFormRadioGroup, InputField } from 'app/components/Core';
import { MarketingCheckbox } from 'app/components/SignUp/MarketingCheckbox';
import { AuthFormHeader } from 'app/components/AuthForm';

export interface SignUpPersonaFormProps {
  userPersonas: Option[];
}

export const SignUpPersonaForm: React.FC<SignUpPersonaFormProps> = ({
  userPersonas,
}) => {
  const {
    watch,
    control,
    register,
    formState: { errors },
  } = useFormContext<SignUpFormFields>();

  const watchPersona = watch('persona');

  return (
    <Flex direction="column" my={2}>
      <AuthFormHeader heading="Create an account" mb={12}>
        Which role do you most <br /> identify with?
      </AuthFormHeader>
      <ChakraFormRadioGroup
        control={control}
        variant="contained"
        name="persona"
        options={userPersonas}
      />
      {watchPersona === 'Other' && (
        <InputField
          placeholder="Please specify your role"
          isInvalid={Boolean(errors.personaOther)}
          errorMessage={errors.personaOther?.message}
          data-testid="persona-other"
          mt={22}
          {...register('personaOther')}
        />
      )}
      <MarketingCheckbox<SignUpFormFields> name="emailOptIn" />
    </Flex>
  );
};
